var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article-layout',[_c('h1',[_vm._v("Pagina niet gevonden")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_c('h2',[_vm._v("Deze pagina bestaat niet!")]),_c('p')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }